import { ITileConfigData } from './tile-config/tile-config.component';
import { IWoodConfigData } from './wood-config/wood-config.component';
import { IFlatConfigData } from './flat-config/flat-config.component';
import { IPhotoConfigData } from './photo-config/photo-config.component';
import { IVideoConfigData } from './video-config/video-config.component';

export type DisplayMode = 'no-wall' | 'tiles' | 'wood' | 'flat' | 'photo' | 'video';

export class MilieuSettings {
    public displayMode: DisplayMode;
    public isHalfHeightWall: boolean;
    public threeDModelTintColor: string;
    public tileConfigData: ITileConfigData;
    public woodConfigData: IWoodConfigData;
    public flatConfigData: IFlatConfigData;
    public photoConfigData: IPhotoConfigData;
    public videoConfigData: IVideoConfigData;

    constructor() {
        this.reset();
    }

    public reset() {
        this.displayMode = 'tiles';
        this.isHalfHeightWall = false;

        this.tileConfigData = {
            tileColor: "#4a4a6f",
            tileOffsetX: 0,
            tileOffsetY: 0,
            tileWidth: 25,
            tileHeight: 13,
            tilesHaveStructure: true,
            jointColor: "#c7c7c7",
            jointWidth: 2
        };
        this.woodConfigData = {
            woodType: "a",
            isHorizontal: false
        };
        this.flatConfigData = {
            wallColor: "#565b6e",
        };
        this.photoConfigData = {
            imageSrc: null,
            scale: 1,
            offsetX: 0,
            offsetY: 0,
        };
        this.videoConfigData = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/configure/configure-milieu/MilieuSettings.ts